import React, {useMemo} from "react";

// Components
import {Typography} from "../../../../designSystem/components/Typography";
import {BeautifulTable} from "../BeautifulTable";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {BeautifulPieChart} from "../BeautifulPieChart";

import {countByCategory} from "../../model/dashboardAnalytics";

type CategoryCountRow = { category: string; count: number };

export const CategorySummary = ({cases}) => {
  const categoryCountArray = useMemo(() => {
    return countByCategory(cases)
  }, [cases])

  return (
    <DashboardCard>
      <Typography variant="subtitle">
        案件組別統計
      </Typography>

      <BeautifulTable<CategoryCountRow>
        rows={categoryCountArray}
        getRowKey={(row) => row.category}
        columns={[
          {
            key: 'question',
            header: <Typography variant="body">類別</Typography>,
            render: (row) => <Typography variant="body">{row.category}</Typography>,
            cellClassName: 'text-gray-800',
          },
          {
            key: 'avg',
            header: <Typography variant="body">案件數</Typography>,
            align: 'right',
            headerClassName: 'text-nowrap',
            cellClassName: 'font-medium text-gray-700',
            render: (row) => <Typography variant="bodyBold">{row.count}</Typography>,
          },
        ]}
      />

      <BeautifulPieChart
        dataKey="count"
        nameKey="category"
        data={categoryCountArray}
      />
    </DashboardCard>
  );
};
